/* eslint-disable max-len */

import { translate, TranslationEntity } from '@repo/utils';
import { type AlertProps } from 'antd';

export const CANVAS_ALERT_MESSAGES: Record<string, AlertProps> = {
  liveEdit: {
    message: 'You are in “Live Edit” Mode',
    description: 'In live edit mode, only actions can be edited. Triggers and Conditions are locked. Unpublish to access full editing.',
    type: 'warning',
  },
  unpublished: {
    message: 'Changes Allowed in this Mode',
    description: translate(`In Unpublished state, content of the nodes can be edited. New nodes can only be added at the end of the #{${TranslationEntity.automation}}. Actions/ Conditions added to the end of #{${TranslationEntity.automation}} can be deleted`),
  },
};
